import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import { Badge, Table, Card } from 'react-bootstrap';
import { Sidebar } from 'primereact/sidebar';
import { Link } from "react-router-dom";
import { Calendar } from 'primereact/calendar';
import axios from "axios";
import { useAuth } from '../context/AuthContext';
import config from '../config';
const ClientOnboardingDetails = ({ clientId }) => {
    const { accessToken } = useAuth();
    const [date, setDate] = useState(new Date());
    const [visibleRight, setVisibleRight] = useState(false);
    const [formsData, setFormsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeItem, setActiveItem] = useState(null);
    const [cardData, setCardData] = useState(null);
    useEffect(() => {
        if (clientId) {
            fetchSubmissions();
        }
    }, [clientId, date]);

    const fetchSubmissions = async () => {
        setLoading(true);
        try {
            const month = date.getMonth() + 1; // JavaScript months are 0-based
            const year = date.getFullYear();

            const response = await axios.get(
                `${config.apiBASEURL}/ClientFormRoutes/specific_client-submitted-forms`,
                {
                    params: { client_id: clientId, month, year },
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );

            if (response.status === 204) {
                setFormsData([]);
            } else {
                setFormsData(response.data);
            }
        } catch (error) {
            console.error("Error fetching client forms:", error);
        }
        setLoading(false);
    };

    const handleListItemClick = (form) => {
        setActiveItem(form.form_submission_id);
        setCardData(form); // Ensuring invoices is always an array
        setVisibleRight(true);
    };



    return (
        <>
            <div className='d-flex justify-content-between align-items-center py-0 border-0 mb-3'>
                <h6>Total : <b className="text-black">{formsData.length}</b><sub> / OBD</sub></h6>
                <Calendar
                    value={date}
                    onChange={(e) => setDate(e.value)}
                    view="month"
                    dateFormat="mm/yy"
                    style={{ width: '100px' }}
                />
            </div>

            {loading ? (
                <p>Loading Onboarding Forms...</p>
            ) : formsData.length === 0 ? (
                <p>No Onboarding Forms found.</p>
            ) : (
                <Accordion activeIndex={0}>
                    {formsData.map((form) => (
                        <AccordionTab
                            key={form.form_submission_id}
                            header={
                                <span className="d-flex align-items-center justify-content-between w-100">
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={require("../assets/images/static_inv.png")}
                                            alt={form.form_name}
                                            style={{ width: "32px", height: "32px", marginRight: "10px" }}
                                        />
                                        <span className="font-bold white-space-nowrap">
                                            {form.form_name}
                                            &nbsp; | &nbsp;
                                            <small style={{ fontWeight: "400" }}>{form.type}</small>
                                            <small className="mt-2 d-block" style={{ fontWeight: "400" }}>
                                                Submission Date:  {new Date(form.submission_date).toLocaleDateString('en-GB')}
                                            </small>
                                        </span>
                                    </div>
                                    <Button
                                        label="INV -> "
                                        className="border-0 py-1 px-2 bg-light"
                                        severity="warning"
                                        badge={form.invoices?.length ? form.invoices.length.toString() : "0"}
                                        outlined
                                        badgeClassName="p-badge-danger"
                                        onClick={() => handleListItemClick(form)}
                                    />
                                </span>
                            }
                        >{form.formDataEntries &&
                            Object.entries(
                                form.formDataEntries.reduce((acc, entry) => {
                                    if (!acc[entry.section_name]) {
                                        acc[entry.section_name] = [];
                                    }
                                    acc[entry.section_name].push(entry);
                                    return acc;
                                }, {})
                            ).map(([sectionName, details], index) => (
                                <Card key={index} className="border-0 shadow-sm p-2 mb-3">
                                    <Card.Body>
                                        <div key={index} className="allempList">
                                            <div className="rol-title">{sectionName}</div>
                                            <ul className="clit_onfileDet">
                                                {details.map((detail) => (
                                                    <li key={detail.form_data_id}>
                                                        <small className="d-block text-warning">{detail.field_label}</small>
                                                        {detail.response || "N/A"}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))
                            }

                        </AccordionTab>
                    ))}
                </Accordion>

            )}


            {/* 
            <Accordion activeIndex={0}>

                <AccordionTab
                    header={
                        <span className="d-flex align-items-center justify-content-between w-full">
                            <div className="d-flex align-items-center">
                                <img
                                    src={require("../assets/images/static_inv.png")}
                                    alt="User"
                                    style={{ width: '32px', height: '32px', marginRight: '10px' }}
                                />

                                <span className="font-bold white-space-nowrap">
                                    Static Invites
                                    &nbsp; | &nbsp;
                                    <small style={{ fontWeight: '400' }}>Wedding related stuff</small>
                                    <small className="mt-2 d-block" style={{ fontWeight: '400' }}>Deadline : 15/01/2025</small>
                                </span>
                            </div>
                            <Button
                                label="INV -> "
                                className="border-0 py-1 px-2 bg-light"
                                severity="warning"
                                onClick={() => setVisibleRight(true)}
                                badge="2"
                                outlined
                                badgeClassName="p-badge-danger"
                            />
                        </span>
                    }
                >
                    <div className="d-flex justify-content-end mb-3 sticky-top bg-white py-2" style={{ top: '-40px' }}>
                        <Button
                            label={editMode ? "Save" : "Edit"}
                            icon={editMode ? "pi pi-save" : "pi pi-pencil"}
                            onClick={toggleEditMode}
                            className="border-0 py-2"
                            severity="help"
                            outlined
                        />
                    </div>
                    <div className="allempList mt-3">
                        <div className="rol-title">Bride</div>
                        <ul className="clit_onfileDet">
                            {Object.entries(formData.bride).map(([key, value]) => (
                                <li key={key}>
                                    <small className="d-block text-warning">{key.replace(/([A-Z])/g, " $1")}</small>
                                    {editMode ? (
                                        <input
                                            type="text"
                                            value={value}
                                            onChange={(e) => handleInputChange("bride", key, e.target.value)}
                                            className="form-control"
                                        />
                                    ) : (
                                        value
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="allempList">
                        <div className="rol-title">Groom</div>
                        <ul className="clit_onfileDet">
                            {Object.entries(formData.groom).map(([key, value]) => (
                                <li key={key}>
                                    <small className="d-block text-warning">{key.replace(/([A-Z])/g, " $1")}</small>
                                    {editMode ? (
                                        <input
                                            type="text"
                                            value={value}
                                            onChange={(e) => handleInputChange("groom", key, e.target.value)}
                                            className="form-control"
                                        />
                                    ) : (
                                        value
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="allempList">
                        <div className="rol-title">Events</div>
                        <ul className="clit_onfileDet">
                            {formData.events.map((event, index) => (
                                <li key={index}>
                                    {Object.entries(event).map(([key, value]) => (
                                        <p key={key}>
                                            <small className="d-block text-secondary">{key}</small>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    value={value}
                                                    onChange={(e) => handleInputChange("events", key, e.target.value, index)}
                                                    className="form-control"
                                                />
                                            ) : (
                                                value
                                            )}
                                        </p>
                                    ))}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="allempList">
                        <div className="rol-title">Deliverables</div>
                        <ul className="clit_onfileDet">
                            {Object.entries(formData.deliverables).map(([key, value]) => (
                                <li key={key}>
                                    <small className="d-block text-warning">{key}</small>
                                    {Array.isArray(value) ? (
                                        value.map((item, idx) => (
                                            <p key={idx}>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        value={item}
                                                        onChange={(e) =>
                                                            handleInputChange("deliverables", key, [
                                                                ...value.slice(0, idx),
                                                                e.target.value,
                                                                ...value.slice(idx + 1),
                                                            ])
                                                        }
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    item
                                                )}
                                            </p>
                                        ))
                                    ) : editMode ? (
                                        <input
                                            type="text"
                                            value={value}
                                            onChange={(e) => handleInputChange("deliverables", key, e.target.value)}
                                            className="form-control"
                                        />
                                    ) : (
                                        value
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="allempList">
                        <div class="rol-title">Zip File</div>
                        <ul className="clit_onfileDet">
                            <li>
                                <small className='d-block text-warning'>Name</small>
                                <div className="d-flex justify-content-between align-items-center ">
                                    avneet-shergill-wedding-pics.zip
                                    <Button
                                        label="Download"
                                        icon="pi pi-download"
                                        className="py-1 border-0 text-center"
                                        severity="danger"
                                        outlined
                                        style={{ width: '180px' }}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                </AccordionTab>
            </Accordion> */}






            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '50vw' }}>
                <div className='d-flex justify-content-start align-items-start'>
                    <img
                        src={require("../assets/images/static_inv.png")}
                        alt="User"
                        style={{ width: '32px', height: '32px', marginRight: '10px' }}
                    />
                    <div className='ms-3'>
                        <h6 className='mb-1 d-block'> {cardData?.form_name} </h6>
                        <small className='d-block text-black'>
                            {cardData?.type}
                        </small>

                        <small className='d-block text-danger'>
                            <em >Deadline</em> : {new Date(cardData?.submission_date).toLocaleDateString('en-GB')}
                        </small>

                    </div>
                </div>
                <hr />
                {cardData?.invoices?.length > 0 ? (
                    <div className='table-responsive mt-4 clsd_inv'>
                        <Table bordered size="sm">
                            <thead>
                                <tr className='table-secondary'>
                                    <th style={{ width: '110px' }}>Invoice No.</th>
                                    <th>Services</th>
                                    <th>Issued On</th>
                                    <th>Amount</th>
                                    <th>IGST/GST</th>
                                    <th className="table-info">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cardData.invoices.map((invoice) => (
                                    <tr key={invoice.invoice_id}>
                                        <th>
                                            <Link to={''} target="_blank" className='text-primary'>
                                                {invoice.invoice_code}
                                            </Link>
                                        </th>
                                        <td>{invoice.template_name}</td>
                                        <td>{new Date(invoice.issue_date).toLocaleDateString('en-GB')}</td>
                                        <td>{invoice.sub_total.toFixed(2)}</td>
                                        

                                        {invoice.tax_type === "Cgst+Sgst" && (
                                            <td>
                                                <small className="d-block border-bottom text-danger">CGST ({invoice.cgst}%) + SGST ({invoice.sgst}%)</small>
                                                {invoice.tax.toFixed(2)}
                                            </td>

                                        )}

                                        {invoice.tax_type === "Igst" && (
                                            <td>
                                                <small className="d-block border-bottom text-danger">IGST ({invoice.igst}%)</small>
                                                {invoice.tax.toFixed(2)}
                                            </td>

                                        )}
                                        {invoice.tax_type === "GST" && (
                                            <td>
                                                <small className="d-block border-bottom text-danger">GST ({invoice.gst}%)</small>
                                                {invoice.tax.toFixed(2)}
                                            </td>

                                        )}
                                        <th className="table-info">{invoice.total.toFixed(2)}</th>
                                    </tr>

                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <p className="text-center mt-4 text-muted">No invoices found.</p>
                )}
            </Sidebar>
        </>
    );
};

export default ClientOnboardingDetails;
